import React from 'react';
import { FaBuilding } from 'react-icons/fa';

const VIDEO_EXTS = ['mp4', 'webm', 'mov', 'ogg', 'mkv'];

export const isVideoUrl = (url) => {
    if (!url) return false;
    const ext = url.split('.').pop().toLowerCase().split('?')[0];
    return VIDEO_EXTS.includes(ext);
};

const UserAvatar = ({ src, alt = 'img', className = '', style = {}, onClick, isCompany = false, isGroup = false }) => {
    // Company with no photo → building icon
    if (isCompany && !isGroup && !src) {
        return (
            <div
                className={`company-avatar-placeholder ${className}`}
                style={{
                    position: 'relative',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgb(200, 200, 200)', borderRadius: '50%',
                    width: '100%', height: '100%', minWidth: 38, minHeight: 38,
                    ...style
                }}
                onClick={onClick}
            >
                {/* Absolute so the icon scales with the avatar without affecting its size */}
                <FaBuilding style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#fff', width: '60%', height: 'auto' }} />
            </div>
        );
    }
    if (isVideoUrl(src)) {
        return (
            <video
                src={src}
                className={className}
                style={{ objectFit: 'cover', display: 'block', maxWidth: '100%', ...style }}
                onClick={onClick}
                autoPlay
                loop
                muted
                playsInline
            />
        );
    }
    return (
        <img
            src={src || (isGroup ? '/images/mystery-group.png' : '/images/default.png')}
            alt={alt}
            className={className}
            style={style}
            onClick={onClick}
        />
    );
};

export default UserAvatar;
